import { render } from "./recent_documents.html?vue&type=template&id=9f4c01ce&external"
import script from "./recent_documents.js?vue&type=script&lang=js&external"
export * from "./recent_documents.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__